// API Configuration
const getApiUrl = () => {
  // Hard fallback based on hostname to prevent environment variable misconfigurations
  // from breaking production or test environments.
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'usubt.com' || window.location.hostname.includes('usub-devtest')) {
      return 'https://usub-api-v2-test-984985019861.us-east1.run.app';
    }
    if (window.location.hostname === 'usublease.com' || window.location.hostname === 'usub.net' || window.location.hostname.includes('usub-admin') || window.location.hostname === 'usubx.com' || window.location.hostname.includes('usubx.com')) {
      return 'https://usub-api-v2-prod-984985019861.us-east1.run.app';
    }
  }

  // In production, use the deployed backend URL
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || '';
  }
  // In development, fall back to the deployed production API ("actual backend")
  return process.env.REACT_APP_API_URL || 'https://usub-api-v2-prod-984985019861.us-east1.run.app';
};

export const API_BASE_URL = getApiUrl();

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/v1/auth/login`,
    REGISTER: `${API_BASE_URL}/api/v1/auth/register`,
    GOOGLE_LOGIN: `${API_BASE_URL}/api/v1/auth/google-login`,
    GOOGLE_COMPLETE_SETUP: `${API_BASE_URL}/api/v1/auth/google-complete-setup`,
    MICROSOFT_LOGIN: `${API_BASE_URL}/api/v1/auth/microsoft-login`,
    REFRESH_TOKEN: `${API_BASE_URL}/api/v1/auth/refresh-token`,
    SEND_VERIFICATION_CODE: `${API_BASE_URL}/api/v1/auth/send-verification-code`,
    VERIFY_EMAIL: `${API_BASE_URL}/api/v1/auth/verify-email`,
  },
  USERS: {
    PROFILE: `${API_BASE_URL}/api/v1/users/profile`,
    STATS: `${API_BASE_URL}/api/v1/users/stats`,
    GET_USER: (userId: string) => `${API_BASE_URL}/api/v1/users/${userId}`,
    PREFERENCES: `${API_BASE_URL}/api/v1/users/preferences`,
    AVATAR: `${API_BASE_URL}/api/v1/users/avatar`,
    VERIFY_STUDENT_BASE64: `${API_BASE_URL}/api/v1/users/verify-student-base64`,
  },
  SUBLEASES: {
    LIST: `${API_BASE_URL}/api/v1/subleases/`,
    CREATE: `${API_BASE_URL}/api/v1/subleases/`,
    CREATE_FACEBOOK: `${API_BASE_URL}/api/v1/subleases/facebook`,
    DETAIL: (id: string) => `${API_BASE_URL}/api/v1/subleases/${id}`,
    STATS_OVERVIEW: `${API_BASE_URL}/api/v1/subleases/stats/overview`,
  },
  ALT_LISTINGS: {
    LIST: `${API_BASE_URL}/api/v1/alt-listings/`,
    CREATE: `${API_BASE_URL}/api/v1/alt-listings/`,
    DETAIL: (id: string) => `${API_BASE_URL}/api/v1/alt-listings/${id}`,
  },
  UNIVERSITIES: {
    LIST: `${API_BASE_URL}/api/v1/universities/`,
  },
  MESSAGES: {
    CONVERSATIONS: `${API_BASE_URL}/api/v1/messages/conversations`,
    ENRICHED_CONVERSATIONS: `${API_BASE_URL}/api/v1/messages/conversations/enriched`,
    CREATE_CONVERSATION: `${API_BASE_URL}/api/v1/messages/conversations`,
    CONVERSATION_MESSAGES: (conversationId: string) => `${API_BASE_URL}/api/v1/messages/conversations/${conversationId}/messages`,
    SEND_MESSAGE: (conversationId: string) => `${API_BASE_URL}/api/v1/messages/conversations/${conversationId}/send`,
    MARK_READ: (conversationId: string) => `${API_BASE_URL}/api/v1/messages/conversations/${conversationId}/read`,
    WITH_USER: (userId: string) => `${API_BASE_URL}/api/v1/messages/conversations/with/${userId}`,
  },
  ADMIN: {
    BASE: `${API_BASE_URL}/api/v1/admin`,
    LOGIN: `${API_BASE_URL}/api/v1/admin/login`,
    TABLES: `${API_BASE_URL}/api/v1/admin/tables`,
    USERS: `${API_BASE_URL}/api/v1/admin/users`,
    LISTINGS: `${API_BASE_URL}/api/v1/admin/listings`,
    PENDING_LISTINGS: `${API_BASE_URL}/api/v1/admin/listings/pending`,
    VERIFY_LISTING: (listingId: string) => `${API_BASE_URL}/api/v1/admin/listings/${listingId}/verify`,
    MODERATE_LISTING: (listingId: string) => `${API_BASE_URL}/api/v1/admin/listings/${listingId}/moderate`,
    VERIFY_ALL_LISTINGS: `${API_BASE_URL}/api/v1/admin/listings/verify-all`,
    UPDATE_LISTING: (listingId: string) => `${API_BASE_URL}/api/v1/admin/listings/${listingId}`,
    BOOST_LISTING: (listingId: string) => `${API_BASE_URL}/api/v1/admin/listings/${listingId}/boost-manual`,
    UNBOOST_LISTING: (listingId: string) => `${API_BASE_URL}/api/v1/admin/listings/${listingId}/unboost-manual`,
    CONVERSATIONS: `${API_BASE_URL}/api/v1/admin/conversations`,
    CONVERSATION_MESSAGES: (conversationId: string) => `${API_BASE_URL}/api/v1/admin/conversations/${conversationId}/messages`,
    STATS: `${API_BASE_URL}/api/v1/admin/stats`,
    DELETE_ITEM: `${API_BASE_URL}/api/v1/admin/delete-item`,
    ACTIVITY: `${API_BASE_URL}/api/v1/admin/activity`,
    UNIVERSITY_SEARCHES: `${API_BASE_URL}/api/v1/admin/university-searches`,
    VISITS: `${API_BASE_URL}/api/v1/admin/visits`,
    TRACK_SEARCH: `${API_BASE_URL}/api/v1/admin/track-search`,
    SEARCH_PERFORMANCE: `${API_BASE_URL}/api/v1/admin/search-performance`,
    BACKEND: `${API_BASE_URL}/api/v1/admin/backend`,
    IMPERSONATE: (userId: string) => `${API_BASE_URL}/api/v1/admin/impersonate/${userId}`,
  },
  UPLOAD: {
    MULTIPLE: `${API_BASE_URL}/api/v1/upload/multiple`,
    MULTIPLE_BASE64: `${API_BASE_URL}/api/v1/upload/multiple-base64`,
    MULTIPLE_BASE64_PUBLIC: `${API_BASE_URL}/api/v1/upload/multiple-base64-public`,
    FROM_URL: `${API_BASE_URL}/api/v1/upload/from-url`,
  },
  FEEDBACK: `${API_BASE_URL}/api/v1/feedback/`,
  FEEDBACK_ADMIN: `${API_BASE_URL}/api/v1/feedback/list`,
  VOTE_UNIVERSITY: `${API_BASE_URL}/api/v1/universities/vote`,
  HEALTH: `${API_BASE_URL}/api/health`,
};

// Feature Flags - Toggle UI features on/off
export const FEATURE_FLAGS = {
  DESCRIPTIONSHOW: true, // Set to true to show descriptions on home screen listing cards
  DEVELOPER_MODE: process.env.REACT_APP_DEVELOPER_MODE === 'true', // Enable developer tools
  SHOWGRID: false, // Show grid borders for debugging (controlled by developer tools)
};

// Caching configuration
export const UNIVERSITY_CACHE = {
  KEY: 'usub_universities_cache',
  EXPIRY: 24 * 60 * 60 * 1000, // 24 hours
};

export default API_BASE_URL;
